import React, { useContext, useEffect, useState } from "react";
import { simpleGetCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "../component/button";
import { AppContext } from "../context/AppContext";

export default function CandidateProfile({ candidate = {} }) {

  const { code, userId } = useParams()

  const { adminData } = useContext(AppContext)

  const [summary, setSummary] = useState({})

  const navigate = useNavigate()


  const data = {
    name: "Vineet Singh",
    email: "vineetsinghd2412@gmail.com",
    phone: "8602042412",
    personalityFit: "Excellent",
    technicalScore: "Not Available Yet",
    totalExperience: "12",
    title: "",
    department: "",
    company: "",
    educationLevel: "",
    educationArea: "",
    location: "Hyderabad",
    salaryExpectations: "7 to 9 Lakhs per Annum",
    availability: "2 Months",
    buyoutOption: "No",
    retortExperience: "Yes",
    grainsMilletsExperience: "Yes",
    fssaiKnowledge: "Yes",
    foodTechDegree: "Yes",
    npdExperience: "Yes",
    notes: [
      { date: "", note: "" },
      { date: "", note: "" },
    ],
    primaryPersonality: {
      name: "Perfectionist (100%)",
      description:
        <p className="font-report">Perfectionists are tenacious, competitive, systematic, and creative individuals with opposing behavioral forces. They seek immediate results and have an equally
          strong desire for perfection. Their ability to plan and achieve quality allows them to make sound decisions. They think and act quickly but also evaluate all options
          before agreeing to a course of action. In their drive for results and perfection, they demand the freedom to explore and the authority to examine. They are
          straightforward and enjoy working by themselves. They tend to be careful with relationships and prefer a strategic approach when dealing with
          others. They are open to change but extremely cautious.</p>
      ,
      strengths:
        <p className="font-report text-base">Tenacity, quality control, handling large amounts of detail, analyzing data, building systems, competing to win, results-focused, striving to be the best
        </p>,
      uniqueness: <p className="font-report text-base">Attention to detail; tries innovative approaches using existing systems
      </p>,
      valueToOrg: <p className="font-report text-base">Can bring positive change to the team by challenging them and raising the standards</p>,
      challenges: <p className="font-report text-base">Bored with routine work; gets lost in detai</p>,
      motivation: <p className="font-report text-base">Unique accomplishments and dominance</p>,
    },
    resumeSummary: "Add Resume Here",
    ...candidate,
  };

  // ------------------------------------------
  // INLINE PAGE STYLE (Your .page CSS)
  // ------------------------------------------
  const pageStyle = {
    width: "210mm",
    minHeight: "297mm",
    margin: "20px auto",
    background: "white",
    position: "relative",
    pageBreakAfter: "always",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    padding: "30px 40px",
    fontFamily: "Calibri, sans-serif",
  };

  //   const tableStyle = {
  //     width: "100%",
  //     border: "1px solid #000",
  //     borderCollapse: "collapse",
  //     marginBottom: 20,
  //     fontSize: 16,
  //   };

  //   const smallCellStyle = {
  //     width: "20%",
  //     borderBottom: "1px solid",
  //     borderRight: "1px solid",
  //     padding: "8px 10px",
  //     verticalAlign: "top",
  //     color: "black",
  //     fontSize: 16,
  //     fontStyle: "italic",
  //   };

  //   const bigCellStyle = {
  //     width: "80%",
  //     borderBottom: "1px solid",
  //     borderLeft: "1px solid",
  //     padding: "8px 10px",
  //     verticalAlign: "top",
  //     color: "black",
  //     fontSize: 16,
  //     fontStyle: "italic",
  //   };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 10,
    fontSize: 16,
    lineHeight: "16px",   // forces height to shrink
  };

  const commonCell = {
    border: "1px solid #000",
    padding: "8px 10px",
    verticalAlign: "top",
    color: 'var(--brand-text)',
    fontSize: 16,
    fontStyle: "italic",
  };

  const bigCellStyle = {
    border: "1px solid #000",
    padding: "8px 10px",
    verticalAlign: "top",
    color: 'var(--brand-text)',
    fontSize: 16,
    width: "80%",
  };
  const responseTableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 10,
    fontSize: 16,
    lineHeight: "5px",   // forces height to shrink

  }
  const responseCellStyle = {
    border: "1px solid #000",
    padding: "8px 10px",
    verticalAlign: "top",
    color: 'var(--brand-text)',
    fontSize: 16,
    fontStyle: "italic",
    width: "90%",
  }

  const responseSmallStyle = {
    border: "1px solid #000",
    padding: "8px 10px",
    verticalAlign: "top",
    color: 'var(--brand-text)',
    fontSize: 16,
    width: "10%"
  }

  const smallCellStyle = {
    ...commonCell,
    width: "20%",
  };
  const otherCellsStyle = {
    ...commonCell,
    width: "25%",

  }



  const greyTableStyle = {
    width: "100%",
    border: "1px solid #d4d4d4",
    borderCollapse: "collapse",
    marginTop: 12,
    fontSize: 12,
    lineHeight: "16px",
  };


  const getSummaryReport = () => {

    simpleGetCallWithErrorResponse(ApiConfig.GET_SUMMARY_REPORT + `UserId=${userId}&Code=${code}&Admin=${adminData?.email}`).then((res) => {


      if (res?.json?.succeded) {
        setSummary(res?.json?.response)
      }

    })

  }

  useEffect(() => {
    getSummaryReport()
  }, [])


  return (
    <>
      {/* ----------------------------------------------------------- */}
      {/* ---------------------------- PAGE 1 ------------------------ */}
      {/* ----------------------------------------------------------- */}
      <div className=' mt-2' style={{ marginLeft: '20px' }}>
        <CustomButton
          title="Back To Candidate List"
          buttonType='secondary'
          handleClick={() => navigate(`/candidateList/${code}`)}
        />
      </div>
      <div style={pageStyle}>
        <h2 >Candidate Summary, {summary?.forPosition}</h2>
        <h2>
          <strong>{summary?.candidateName}</strong>
        </h2>

        <p className="font-size-h3" style={{ marginBottom: 10, marginTop: 20 }}>
          <strong>Personal Details</strong>
        </p>

        <table style={tableStyle}>
          <tbody>
            <tr>
              <td style={smallCellStyle}>Name</td>
              <td style={bigCellStyle}>{summary?.candidateName}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Email</td>
              <td style={bigCellStyle}>{summary?.email}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Phone</td>
              <td style={bigCellStyle}>{summary?.mobile}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Personality Fit</td>
              <td style={bigCellStyle}>{summary?.personalityMatch}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Technical Score</td>
              <td style={bigCellStyle}>{summary?.technicalScore}</td>
            </tr>
            {/* <tr>
              <td style={{ ...smallCellStyle, borderBottom: 0 }}>Technical Score</td>
              <td style={{ ...bigCellStyle, borderBottom: 0 }}>{data.technicalScore}</td>
            </tr> */}
          </tbody>
        </table>

        <p className="font-size-h3" style={{ marginBottom: 10, marginTop: 20 }}>
          <strong>Current Job & Educational Qualifications</strong>
        </p>

        <table style={tableStyle}>
          <tbody>
            <tr>
              <td style={smallCellStyle}>Total Experience</td>
              <td style={bigCellStyle}>{summary?.yearsOfExperience}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Title</td>
              <td style={bigCellStyle}>{summary?.currentJobTitle}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Department</td>
              <td style={bigCellStyle}>{summary?.currentDepartment}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Company</td>
              <td style={bigCellStyle}>{summary?.currentCompany}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Education Level</td>
              <td style={bigCellStyle}>{summary?.educationLevel}</td>
            </tr>
            <tr>
              <td style={smallCellStyle}>Education Area</td>
              <td style={bigCellStyle}>{summary?.educationalArea}</td>
            </tr>
          </tbody>
        </table>

        <p className="font-size-h3" style={{ marginBottom: 10, marginTop: 20 }}>
          <strong>Other Information</strong>
        </p>

        <table style={tableStyle}>
          <tbody>
            <tr>
              <td style={otherCellsStyle}>Location</td>
              <td style={bigCellStyle}>{summary?.currentLocation}</td>
            </tr>
            <tr>
              <td style={otherCellsStyle}>Salary Expectations</td>
              <td style={bigCellStyle}>{summary?.expectedSalary}</td>
            </tr>
            <tr>
              <td style={otherCellsStyle}>Availability</td>
              <td style={bigCellStyle}>{summary?.availableBy?.split("T")[0]}</td>
            </tr>
          </tbody>
        </table>

        <p className="font-size-h3" style={{ marginBottom: 10, marginTop: 20 }}>
          <strong>Yes or No Responses</strong>
        </p>

        <table style={responseTableStyle}>
          <tbody>
            {
              summary?.customQuestions?.map((ques, index) => {

                let current = index + 1
                return <tr>
                  <td style={responseCellStyle}>{ques?.questionText}</td>
                  <td style={responseSmallStyle}>{summary['ans' + current] || 'N/A'}</td>
                </tr>
              })
            }

          </tbody>
        </table>


        <p className="font-size-h3" style={{ marginBottom: 10, marginTop: 20 }}>
          <strong>Notes</strong>
        </p>

        <table style={tableStyle}>
          <tbody>
            <tr>
              <td style={{ ...responseSmallStyle, width: "17%" }}>Date</td>
              <td style={bigCellStyle}>Note</td>
            </tr>

            {summary?.adminNotes?.map((n, i) => (
              <tr key={i}>
                <td style={responseSmallStyle}>{n?.createdAt?.split('T')[0]}</td>
                <td style={bigCellStyle}>{n?.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ----------------------------------------------------------- */}
      {/* ---------------------------- PAGE 2 ------------------------ */}
      {/* ----------------------------------------------------------- */}

      <div style={pageStyle}>
        <h2 style={{ marginTop: 12 }}>Candidate Summary, {summary?.forPosition}

        </h2>
        <h2>
          <strong>{summary?.candidateName}</strong>
        </h2>

        <h3 className="font-size-h3" style={{ marginTop: 12 }}><strong>Personalities</strong></h3>

        <p className="text-dark" style={{ textDecoration: "underline" }}>Ideal Behaviors for the Role</p>
        <p className="text-dark">{summary?.selectedBehaviourMatch1?.map((i) => i?.behaviourName).join(',')}</p>

        <p className="text-dark" style={{ textDecoration: "underline" }}>
          Primary Personality: {summary?.primaryProfileName} ({summary?.primaryProfilePercent})
        </p>

        <p className="font-size-h3 text-dark" style={{ marginTop: 4, fontStyle: "italic", marginBottom: "0" }}>
          <strong>Description:</strong>
        </p>

        <p className="font-report text-dark" style={{ fontSize: 'var(--font-size-sm)', marginTop: "0" }}>

          <p className="font-report">{summary?.primaryProfile?.longText}</p>
        </p>

        <table style={greyTableStyle}>
          <tbody>
            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", width: "12%" }}>
                <strong>Strengths</strong>
              </td>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <p className="font-report text-base">{summary?.primaryProfile?.strengths}
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <strong>Uniqueness</strong>
              </td>
              <td style={{ padding: 6 }}>
                <p className="font-report text-base">{summary?.primaryProfile?.theirUniqueness}</p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <strong>Value to Org.</strong>
              </td>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <p className="font-report text-base">{summary?.primaryProfile?.valueToOrganization}</p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <strong>Challenges</strong>
              </td>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <p className="font-report text-base">{summary?.primaryProfile?.challenges}</p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <strong>Motivation</strong>
              </td>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <p className="font-report text-base">{summary?.primaryProfile?.motivations}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="text-dark" style={{ textDecoration: "underline", marginTop: '20px' }}>
          Secondary Personality: {summary?.secondaryProfileName} ({summary?.secondaryProfilePercent})

        </p>
        {/* <p style={{marginTop:”0”, fontSize: 15,fontStyle:”italic”, color: “black” }}>
        <strong> “Same as Above”</strong>

        </p> */}
        <p className="font-size-h3 text-dark" style={{ marginTop: 4, fontStyle: "italic", marginBottom: "0" }}>
          <strong>Description:</strong>
        </p>

        <p className="font-report text-dark" style={{ fontSize: 'var(--font-size-sm)', marginTop: "0" }}>
          <p className="font-report"> {summary?.secondaryProfile?.longText}</p>
        </p>

        <table style={greyTableStyle}>
          <tbody>
            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", width: "12%" }}>
                <strong>Strengths</strong>
              </td>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <p className="font-report text-base">{summary?.secondaryProfile?.strengths}</p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <strong>Uniqueness</strong>
              </td>
              <td style={{ padding: 6 }}>
                <p className="font-report text-base">{summary?.secondaryProfile?.theirUniqueness}</p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <strong>Value to Org.</strong>
              </td>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <p className="font-report text-base">{summary?.secondaryProfile?.valueToOrganization}</p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <strong>Challenges</strong>
              </td>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <p className="font-report text-base">{summary?.secondaryProfile?.challenges}</p>
              </td>
            </tr>

            <tr>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <strong>Motivation</strong>
              </td>
              <td style={{ padding: 6, border: "1px solid #d4d4d4", }}>
                <p className="font-report text-base">{summary?.secondaryProfile?.motivations}</p>
              </td>
            </tr>
          </tbody>
        </table>
        {/* <p style={{ marginTop: 12, fontStyle: "italic", fontSize: 22, color: "gray" }}>
          {data.resumeSummary}
        </p> */}
        <div style={{ width: "100%", height: "100vh", marginTop: '10px' }}>
          <iframe
            src={`${summary?.resume}#toolbar=0&navpanes=0&scrollbar=0`}
            title="Resume Viewer"
            width="100%"
            height="100%"
            style={{

              borderRadius: "none"
            }}
          />
        </div>

      </div >
    </>
  );
}
